module.exports = __webpack_public_path__ + "static/media/flip_to_front.90edae31.svg";